import React, { Component } from 'react';
import { Container, Row, Col, Breadcrumb, Badge } from 'react-bootstrap';
import SessionListView from './sessions/index';
import SessionView from './session/index';
import ExecutionView from './execution/index';
import Navigation from 'context/nav';
import Preferences, { withPreferences } from 'context/preferences';
import Alias from 'components/controls/alias';

export class DebuggerShell extends Component {
  /**
   * The following routes are supported here:
   *
   * - /:orgId/:blobId/debugger
   *   Entry point, renders the list of sessions
   *
   * - /:orgId/:blobId/debugger/:sessionId
   *   Renders session details, list of executions
   *
   * - /:orgId/:blobId/debugger/:sessionId/:executionId
   *   Execution tracking
   */

  constructor(props) {
    super(props);
    // The breadcrumb labels a session by name when one is available. This shell has no session of
    // its own — it renders from the route param — and a breadcrumb is not worth a network
    // round-trip, so it takes the record SessionView has already fetched and falls back to the id.
    this.state = { session: null };
  }

  onSessionLoaded = (session) => {
    this.setState({ session: session });
  }

  onClick(event, path) {
    event.preventDefault();
    this.props.history.push(path);
  }

  render() {
    const orgId = this.props.match.params.orgId;
    const blobId = this.props.match.params.blobId;
    const section = this.props.match.params.section;
    const sessionId = ( "debugger" == section ) ? this.props.match.params.sectionId : null;
    const executionId = ( "debugger" == section ) ? this.props.match.params.subSectionId : null;

    // Only trust a lifted record that belongs to the session currently routed to — otherwise
    // navigating from one session to another would briefly label the new route with the old name.
    const session = ( this.state.session && this.state.session.id === sessionId ) ? this.state.session : null;

    const canEditRevision = this.props.app.api.canUpdateRevision(this.props.blob, this.props.revision);
    const timezone = this.props.preferences["app.timezone"];

    const rootLink = ( sessionId ? true : false );
    const sessionLink = ( executionId ? true : false );
    const executionLink = false;

    return (
      <>
        <Container className="blob-header-row content-row">
          <Row>
            <Col>
              <Breadcrumb
                listProps={{ className: "shell-breadcrumb" }}
                style={{
                  "margin-bottom": "-4px"
                }}>
                <Breadcrumb.Item
                  onClick={(event) => {
                    this.onClick(event, Navigation.workflowPath(orgId, blobId, "debugger"))
                  }}
                  active={!rootLink}>
                  Sessions
                </Breadcrumb.Item>
                {sessionId &&
                  <>
                    <Breadcrumb.Item
                      onClick={(event) => {
                        this.onClick(event, Navigation.workflowPath(orgId, blobId, "debugger", sessionId))
                      }}
                      active={!sessionLink}>
                      Session&nbsp;&nbsp;
                      {( session && session.alias )
                        ? <Alias value={session.alias} />
                        : <Badge className="title-tag-badge">{sessionId}</Badge>}
                    </Breadcrumb.Item>

                    {executionId &&
                      <Breadcrumb.Item
                        onClick={(event) => {
                          this.onClick(event, Navigation.workflowPath(orgId, blobId, "debugger", sessionId, executionId))
                        }}
                        active={!executionLink}>
                        Execution&nbsp;&nbsp;
                        <Badge className="title-tag-badge">{executionId}</Badge>
                      </Breadcrumb.Item>
                    }
                  </>
                }
              </Breadcrumb>
            </Col>
          </Row>
        </Container>

        {!sessionId &&
          <SessionListView
            app={this.props.app}
            blob={this.props.blob}
            revision={this.props.revision}
            canEditRevision={canEditRevision}
            match={this.props.match}
            history={this.props.history}
            location={this.props.location}
            timezone={timezone}
          />
        }
        {( ( "debugger" === section ) && sessionId && !executionId ) &&
          <SessionView
            app={this.props.app}
            blob={this.props.blob}
            revision={this.props.revision}
            canEditRevision={canEditRevision}
            match={this.props.match}
            history={this.props.history}
            location={this.props.location}
            timezone={timezone}
            onSessionLoaded={this.onSessionLoaded}
          />
        }
        {( ( "debugger" === section ) && sessionId && executionId ) &&
          <ExecutionView
            app={this.props.app}
            blob={this.props.blob}
            revision={this.props.revision}
            canEditRevision={canEditRevision}
            match={this.props.match}
            history={this.props.history}
            location={this.props.location}
            timezone={timezone}
          />
        }
      </>
    );
  }
}

export default withPreferences(DebuggerShell, ["app.timezone"],
  props => ({ orgId: props.org.id, blobId: props.blob.id }));
